import React from 'react'
import { IconCheck } from '@tabler/icons-react'
import Typography from '../../atoms/Typography'
import { formatDate } from '../../../enviroment/lib/formatters/format-date'
import { formatFileSize } from '../../../enviroment/lib/formatters/format-file-size'
import { DataRoomDocument } from '../../../types/projects'
import { CardHeader } from './CardHeader'

interface DataRoomDocumentCardProps {
  doc: DataRoomDocument
  onClick: () => void
  actionsEnabled?: boolean
  isSelected?: boolean
  onToggleSelect?: (id: string) => void
}

export const DataRoomDocumentCard: React.FC<DataRoomDocumentCardProps> = ({
  doc,
  onClick,
  actionsEnabled = false,
  isSelected = false,
  onToggleSelect,
}) => {
  return (
    <div
      onClick={onClick}
      className={`group cursor-pointer rounded-lg border px-4 py-3 transition-colors ${
        isSelected
          ? 'border-light-green-600 bg-light-green-500/10'
          : 'border-gray-700 hover:border-light-green-600 hover:bg-light-green-500/10'
      }`}
    >
      <CardHeader
        name={doc.name}
        trailing={
          actionsEnabled && (
            <button
              role="checkbox"
              aria-checked={isSelected}
              aria-label={`Select ${doc.name}`}
              onClick={(e) => {
                e.stopPropagation()
                onToggleSelect?.(doc.id)
              }}
              className={`flex h-5 w-5 shrink-0 items-center justify-center rounded border transition-colors ${
                isSelected
                  ? 'border-light-green-500 bg-light-green-500 opacity-100'
                  : 'border-gray-500 bg-transparent opacity-0 group-hover:opacity-100'
              }`}
            >
              {isSelected && <IconCheck className="h-3 w-3 text-gray-900" strokeWidth={3} />}
            </button>
          )
        }
      />
      {doc.description && (
        <Typography variant="xs" className="mb-3 line-clamp-2 text-gray-200">
          {doc.description}
        </Typography>
      )}
      {/* Clears CardHeader's icon (w-4) plus its gap-2, so this row starts under the file name */}
      <div className="flex items-center gap-2 pl-6">
        <Typography variant="xs" className="text-gray-400">
          {formatDate(doc.createdAt)}
        </Typography>
        <Typography variant="xs" className="text-gray-400">
          &#8226;
        </Typography>
        <Typography variant="xs" className="text-gray-400">
          {formatFileSize(doc.fileSize)}
        </Typography>
      </div>
    </div>
  )
}
